import { difference } from 'lodash-es';

function split(route: string) {
  const routes = route.split('/');
  const result: string[] = [];
  let current = '';
  let tmp = '';
  while ((tmp = routes.shift())) {
    current = current + '/' + tmp;
    result.push(current.substring(1));
  }
  return result;
}

export function splitRoutes(route: string, from = '') {
  const next = split(route);
  const last = split(from);
  const created = difference(next, last);
  const removed = difference(last, next);
  return {
    created,
    removed,
  };
}
